export default __webpack_public_path__ + "static/media/fNeutral3.086fd625.png";